import * as React from "react";
import { Link } from "react-router-dom";
import { Props } from "../../types/common";
import "./styles.scss";

interface LinkButtonProps
    extends Props,
        React.AnchorHTMLAttributes<HTMLAnchorElement> {
    to?: string;
    color: "primary" | "secondary";
    lines?: 1 | 2;
}

const LinkButton = ({
    children,
    to,
    color,
    lines = 1,
    ...restOfProps
}: LinkButtonProps) => {
    return (
        <Link
            to={to}
            className={"link-button " + color + " line-" + lines}
            {...restOfProps}
        >
            {children}
        </Link>
    );
};

export default LinkButton;
